import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef, useCallback } from 'react'
import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, getAction, inferFileType, printVariable } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase, Stack } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import useDelegate from '@hooks/useDelegate'
import useAlert from '@hooks/useAlert'
import { fetchSmst, fetchRegis } from '@pages/manager/manager-lecture.page'
import no_image from '@images/no_image.png'
import { MAX_FILE_SIZE } from '@util/constant'
import { Close } from '@mui/icons-material'
import ConfirmDialog from '@components/ConfirmDialog'
import { schoolGrades } from '@util/schoolInfo'
import NumericTextField from '@components/NumericTextField'

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`

const customTheme = createTheme({
  typography: { fontSize: 12 },
  spacing: 4,
})

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
  font-size: 0.85rem !important;
`
const RLTN_CODE = 'S003'
const g_sel_code = 'SA07'
const g_stat_code = 'SA08'
const g_week_code = 'SB07'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'
const ManagerLecturePartDetail = ({ fields, record, dialogHandler, callback, setCloseHandler }) => {
  console.log('ManagerLecturePartDetail rendering...')
  const inputRef = useRef()
  const [detailScreen, set_detailScreen] = useState(false)
  const [saveDisable, set_saveDisable] = useState(true)
  const [imgUrl, set_imgUrl] = useState(record.imgUrl)
  const { alert, renderAlert } = useAlert()
  const [smst, set_smst] = useState()
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const theme = useTheme()
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const updateRef = useRef(false)
  const [counter, set_counter] = useState(100000)
  const [editArea, set_editArea] = useState({
    base: false,
    lsch: false,
    grade: false,
    content: false,
    fee: false,
  })
  const editAreaRef = useRef(editArea)

  // const originRef = useRef(JSON.parse(JSON.stringify(record)))
  const originRef = useRef(JSON.parse(JSON.stringify({...record, lectureTeachers: record.teachers})))


  const weekCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === 'SB07')
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])
  const selCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === 'SA07')
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])
  const statCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === 'SA08')
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])
  const feeCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === 'SA21').sort((a, b) => a.sqNum - b.sqNum)
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])
  const findSmst = (smstId) => {
    return record.smstList?.find((r) => r.id === smstId)
  }
  const fetchPrevLectures = async (smstId) => {
    const url = `/lecture/prev/school/${schola.id}/smst/${smstId}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }
  const defLschList = useMemo(() => {
    const lschList = []
    const lsch = {
      id: -1,
      lectureId: -1,
      weekCode: '-1',
      startTime: 'null',
      endTime: null,
    }
    codes
      .filter((c) => c.codeGroupId === g_week_code)
      .forEach((w) => {
        lschList.push({ ...lsch, weekCode: w.code })
      })
    return lschList
  }, [])

  const ltgList = useMemo(() => {
    const ltgList = []
    const ltg = {
      id: -1,
      lectureId: -1,
      grade: -1,
    }
    const grades = schoolGrades[schola?.id] ?? [1,2,3,4,5,6]
    for(const grade of grades) {
      ltgList.push({ ...ltg, grade: grade })
    }
    // for (let i = 1; i < 11; i++) {
    //   ltgList.push({ ...ltg, grade: i })
    // }
    return ltgList
  }, [])

  const onLoad2 = async () => {
    openIndicator()
    // 저장 가능한지 체크
    let okCount = 0
    if (record.id === -1) {
      okCount = 2
    }
    else {
      const smst = await fetchSmst(record.id)
      if (smst) {
        set_smst(smst)
        if (smst.phase < 1) {
          okCount = 2
        }
      }
    }
    if (okCount >= 2) {
      set_saveDisable(false)
    }
    closeIndicator()
  }
  const onLoad = async () => {
    if (record.smstId > 0) {
      openIndicator()
      const prevLectures = await fetchPrevLectures(record.smstId)
      closeIndicator()
      if (prevLectures) {
        set_prevLectures(prevLectures)
      }
      const smst = findSmst(record.smstId)
      if (smst) {
        await handleChange({ target: { name: 'selCode', value: smst.selCode } }, () => updateState())
      }
    }
  }
  const canEdit = (area) => {
    if (record.id === -1) {
      return true
    }
    else {
      // if (record.statCode === 'S004') {
      //   return false
      // }
      // if (record.phase >= 1) {
      //   return false
      // }
      if(editArea) {
        return editArea[area]
      }
      return false
    }
    // if(smst) {
    //   if(smst.phase >= 1) {
    //     return false
    //   }
    //   return true
    // }
  }
  const findCode = (codeGroupId, code) => {
    const found = codes.filter((d) => d.codeGroupId === codeGroupId).find((d) => d.code === code)
    return found
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }))
  const visibleColumns = fields.filter((col) => col.visible)
  const xs = 12 / visibleColumns.length <= 3 ? 3 : 12 / visibleColumns.length
  const lschList = []
  const ltgList2 = []

  const generateData = (table) => {
    const lecture = { ...factor, id: factor.id, title: factor.title.trim() }
    if(table === 'lectures') {
      return lecture
    }
    else if(table === 'lschList') {
      const temp = activeRow.lschList.filter((lsch) => lsch.startTime !== null || lsch.endTime !== null)
      const datum = JSON.parse(JSON.stringify(temp))
      datum.forEach((lsch) => {
        lsch.lectureId = lecture.id
        // lsch.startTime = moment(new Date(lsch.startTime)).format("HH:mm")
        // lsch.endTime = moment(new Date(lsch.endTime)).format("HH:mm")
        lsch.startTime = moment(lsch.startTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        lsch.endTime = moment(lsch.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
      })
      return datum
    }
    else if(table === 'ltgList') {
      const datum = activeRow.ltgList
      datum.forEach((ltg) => {
        ltg.lectureId = lecture.id
      })
      return datum
    }
    else if(table === 'feeList') {
      const datum = activeRow.feeList
      datum.forEach((fee) => {
        fee.lectureId = lecture.id
      })
      return datum
    }
    else if(table === 'lectureTeachers') {
      const datum = []
      for(const r of lectureTeachers) {
        const d = {
          id: -1,
          userId: r.id,
          lectureId: lecture.id,
          rltnCode: 'S003',
          regTime: moment(new Date()).format(dateFormat),
        }
        datum.push(d)
      }
      return datum

    }
    else if(table === 'interLectures') {
      const datum = []
      interLectures.forEach((r) => {
        const d = {
          id: -1,
          lectureId: lecture.id,
          prevId: r.id,
          regTime: moment(new Date()).format(dateFormat),
        }
        datum.push(d)
      })
      return datum
    }
  }

  const onSubmit = async () => {


    /*
    if (!files[0].name) {
      alert("강좌 소개파일이 비어 있습니다.")
      return
    }
    */
    if (files.length > 1) {
      alert('한 개 이상의 강좌 소개파일이 존재합니다.')
      return
    }
    if (errors.length > 0) {
      alert('에러가 존재합니다. 화면에서 에러를 확인하세요.')
      return
    }
    const lecture = { ...activeRow, id: factor.id, title: activeRow.title.trim() }

    const temp = activeRow.lschList.filter((lsch) => lsch.startTime !== null || lsch.endTime !== null)
    const datum1 = JSON.parse(JSON.stringify(temp))
    datum1.forEach((lsch) => {
      lsch.lectureId = lecture.id
      // lsch.startTime = moment(new Date(lsch.startTime)).format("HH:mm")
      // lsch.endTime = moment(new Date(lsch.endTime)).format("HH:mm")
      lsch.startTime = moment(lsch.startTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
      lsch.endTime = moment(lsch.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
    })
    const datum2 = activeRow.ltgList
    datum2.forEach((ltg) => {
      ltg.lectureId = lecture.id
    })
    const datum3 = activeRow.feeList
    datum3.forEach((fee) => {
      fee.lectureId = lecture.id
    })

    const datum4 = []
    lectureTeachers.forEach((r) => {
      const d = {
        id: -1,
        userId: r.id,
        lectureId: lecture.id,
        rltnCode: 'S003',
        regTime: moment(new Date()).format(dateFormat),
      }
      datum4.push(d)
    })

    const datum5 = []
    interLectures.forEach((r) => {
      const d = {
        id: -1,
        lectureId: lecture.id,
        prevId: r.id,
        regTime: moment(new Date()).format(dateFormat),
      }
      datum5.push(d)
    })

    const data = {
      lecture: JSON.stringify(lecture),
      lschList: JSON.stringify(datum1),
      ltgList: JSON.stringify(datum2),
      feeList: JSON.stringify(datum3),
      lectureTeachers: JSON.stringify(datum4),
      interLectures: JSON.stringify(datum5),
      oldAttchIdList: attchList.map((a) => a.id),
    }
    const formData = new FormData()
    files.forEach((file, index) => {
      if (file instanceof File) {
        // formData.append(`files`, file)
        const f = new File([file], file.name, { type: file.type })
        formData.append('files', f)
      }
    })

    const jsonData = JSON.stringify(data)
    formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    const url = '/lecture'
    // use axios directly with config and
    /* spring take parameter like this,
       @RequestPart(value = "body", required = true) body: String,
       @RequestPart(value = "files", required = false) files: java.util.List[MultipartFile]
     */
    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    closeIndicator()

    if (resp.data.repCode === 'ack') {
      const repMessage = JSON.parse(resp.data.repMessage)
      const record = JSON.parse(repMessage.record)
      await handleChange({ target: { name: 'id', value: record.id } })
      updateState()
      updateRef.current = true
      alert('저장되었습니다.', () => handleClose())
    }
    else {
      alert(resp.data.repMessage)
    }
  }
  const onChangeWeek = async (weekCode, e) => {
    const week = weekCodeList.find((d) => d.id === weekCode)
    const found = factor.weekCodeList.find((d) => d.id === weekCode)
    if (found && !e.target.checked) {
      const idx = factor.weekCodeList.indexOf(found)
      factor.weekCodeList.splice(idx, 1)
      const lsch = factor.lschList.find((lsch) => lsch.weekCode === weekCode)
      lsch.startTime = null
      lsch.endTime = null
    }
    if (!found && e.target.checked) {
      factor.weekCodeList.push(week)
    }

    handleChange({target:{ name: 'weekCodeList', value: factor.weekCodeList}})
    handleChange({ target: { name: 'weekTime', value: factor.weekCodeList } })


  }
  const onChangeGradeOld = async (grade, e) => {
    const ltg = ltgList.find((d) => d.grade === grade)
    const found = activeRow.ltgList.find((d) => d.grade === grade)
    if (found && !e.target.checked) {
      const idx = activeRow.ltgList.indexOf(found)
      activeRow.ltgList.splice(idx, 1)
    }
    if (!found && e.target.checked) {
      activeRow.ltgList.push(ltg)
    }
  }
  const onChangeGrade = async (grade, e) => {
    const ltg = ltgList.find((d) => d.grade === grade)
    const found = factor.ltgList.find((d) => d.grade === grade)
    if (found && !e.target.checked) {
      const idx = factor.ltgList.indexOf(found)
      factor.ltgList.splice(idx, 1)
    }
    if (!found && e.target.checked) {
      factor.ltgList.push(ltg)
    }

    handleChange({ target: { name: 'ltgList', value: factor.ltgList } })

  }
  const validate = async (name, value) => {
    let err = ''
    if (name === 'smstId') {
      // console.log('smstId ===>', value)
      if (!value || value === -1) {
        err = '년도/기수가 선택되지 않았습니다.'
      }
    }
    if (name === 'userId') {
      if (!value) {
        err = '강사가 선택되지 않았습니다.'
      }
    }
    if (name === 'title') {
      if (!value) {
        err = '강좌 제목을 입력하세요.'
      }
    }
    if (name === 'rcrNum') {
      const regex = /^[1-9][0-9]*$/
      if (!regex.test(value)) {
        err = '모집 인원은 1 이상의 숫자여야 합니다.'
      }
    }
    if (name === 'selCode') {
      if (!value) {
        err = '선발방식을 선택하세요.'
      }
    }
    // if (name === 'prevId') {
    // 	if (factor.selCode === 'S001') {
    // 		if (+value <= 0 || !value) {
    // 			err = '선발방식이 기수강자 우선이면 선행강좌를 선택해야 합니다.'
    // 		}
    // 	}
    // }

    if (name === 'loc') {
      if (!value) {
        err = '장소정보를 입력해 주세요.'
      }
    }
    /*
    if (name === "content") {
      if (!value) {
        err = "강좌 내용을 입력해 주세요."
      }
    }
    */

    if(name === 'weekCodeList') {
      if(value.length === 0) {
        err = '한 개 이상의 요일이 선택되어야 합니다.'
      }
    }

    if(name === 'weekTime') {
      for (const w of factor.weekCodeList) {
        const found = factor.lschList.find((lsch) => lsch.weekCode === w.code)
        if (found) {
          if (found.startTime === null || found.endTime === null) {
            err = '요일은 선택되었으나 시작시간 또는 종료시간이 선택되지 않은 데이터가 있습니다.'
            break
          }
          else {
            const startTime = moment(found.startTime, 'YYYY-MM-DD HH:mm:ss')
            const endTime = moment(found.endTime, 'YYYY-MM-DD HH:mm:ss')
            if (!startTime.isBefore(endTime)) {
              err = '시작시간이 종료시간 보다 이전이 아닌 데이터가 있습니다.'
              break
            }
          }
        }
      }
    }

    if(name === 'ltgList') {
      if(value.length === 0) {
        err = '한 개 이상의 학년이 선택되어야 합니다.'
      }
    }

    if(name === 'feeList') {
      if(value.length === 0) {
        err = '한 개 이상의 요금이 선택되어야 합니다.'
      }
    }

    if(name === 'feePrice') {
      const regex = /^[1-9][0-9]*$/
      for(const fee of activeRow.feeList) {
        if ('' + fee.price === '0') {
          // do nothing
        }
        else {
          if (!regex.test(fee.price)) {
            err = '요금 가격에 잘못된 데이터가 있습니다.'
            break
          }
        }
      }
    }
    if (name === 'lecCount') {
      if (factor.autoLeccntYn === 'N') {
        if (!value || +value < 1) {
          err = '강좌 횟수는 1 이상이어야 합니다.'
        }
      }
    }

    // if (name === 'error') {
    //   if (activeRow.weekCodeList.length === 0) {
    //     err = '한 개 이상의 요일이 선택되어야 합니다.'
    //   }
    //   else {
    //     for (const w of activeRow.weekCodeList) {
    //       const found = activeRow.lschList.find((lsch) => lsch.weekCode === w.code)
    //       if (found) {
    //         if (found.startTime === null || found.endTime === null) {
    //           err = `${err}\n요일은 선택되었으나 시작시간 또는 종료시간이 선택되지 않은 데이터가 있습니다.`
    //           break
    //         }
    //         else {
    //           const startTime = moment(found.startTime, 'YYYY-MM-DD HH:mm:ss')
    //           const endTime = moment(found.endTime, 'YYYY-MM-DD HH:mm:ss')
    //           if (!startTime.isBefore(endTime)) {
    //             err = `${err}\n시작시간이 종료시간 보다 이전이 아닌 데이터가 있습니다.`
    //             break
    //           }
    //         }
    //       }
    //     }
    //   }
    //   if (activeRow.ltgList.length === 0) {
    //     err = `${err}\n한 개 이상의 대상 학년이 선택되어야 합니다.`
    //   }
    //   if (activeRow.feeList.length === 0) {
    //     err = `${err}\n한 개 이상의 강좌 요금이 선택되어야 합니다.`
    //   }
    //   else {
    //     const regex = /^[1-9][0-9]*$/
    //     activeRow.feeList.forEach((fee) => {
    //       if ('' + fee.price === '0') {
    //         // do nothing
    //       }
    //       else {
    //         if (!regex.test(fee.price)) {
    //           err = `${err}\n요금 가격에 잘못된 데이터가 있습니다.`
    //         }
    //       }
    //     })
    //   }
    // }
    return err
  }

  const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  })
  const [emailError, setEmailError] = useState('')
  const [passwordState, setPasswordState] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [nameError, setNameError] = useState('')
  const [registerError, setRegisterError] = useState('')
  const [teacherList, _set_teacherList] = useState([])
  const [files, set_files] = useState([])
  const [attchList, set_attchList] = useState([...record.attchList])
  const [prevLectures, set_prevLectures] = useState([])
  const [lectureTeachers, set_lectureTeachers] = useState([...record.teachers])
  const [interLectures, set_interLectures] = useState([...record.interLectures])
  const btnRef1 = useRef()
  // const Boxs = styled(Box)`
  //   padding-bottom: 40px !important;
  // `;
  const set_teacherList = async () => {
    const schoolId = schola.id
    const rltnCode = 'S003'
    const url = '/user/school'
    const resp = await WebService.get(url, {
      schoolId: schoolId,
      rltnCode: rltnCode,
    })
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.sort((a, b) => a.name.localeCompare(b.name))
      records.unshift({ id: -1, name: '없음' })
      _set_teacherList(records)
    }
    else {
      _set_teacherList([])
    }
  }
  const handleClose_trash = (event, reason) => {
    if(reason && reason === 'backdropClick') {
      return
    }
    else {
      dialogHandler[1](false)
      if (callback) {
        callback(updateRef.current)
      }
    }
  }

  const handleClose = (event, reason) => {
    if(reason && reason === 'backdropClick') {
      return
    }

    if(record.id >= 0) {

      for(const [name, value] of Object.entries(editAreaRef.current)) {
        if(value) {
          alert('현재 편집 중인 데이터가 있습니다. 취소 또는 저장을 선택 후 창을 닫아 주세요.')
          return
        }
      }
    }
    dialogHandler[1](false)
    if (callback) {
      callback(updateRef.current)
    }
  }

  const onChangeFile = (e) => {
    const files = Array.from(e.target.files)
    const file = files[0]
    if (file.size > MAX_FILE_SIZE) {
      alert('파일 크기는 1MB 이하만 가능합니다.')
      return
    }
    const reader = new FileReader()
    reader.onload = () => {
      set_imgUrl(reader.result)
    }
    reader.readAsDataURL(file)
    set_files(files)
    set_attchList([])
  }
  useEffect(() => {
    onLoad()
    set_teacherList()
  }, [])

  useEffect(() => {
    editAreaRef.current = editArea
  }, [editArea])

  useEffect(() => {
    if(setCloseHandler) {
      console.log('setCloseHandler...')
      setCloseHandler(handleClose)
    }
  }, [setCloseHandler])

  const onChangeSmstId = async (e) => {
    const prevLectures = await fetchPrevLectures(e.target.value)
    if (prevLectures) {
      set_prevLectures(prevLectures)
    }
    handleChange(e)
    const smst = findSmst(+e.target.value)
    if (smst) {
      handleChange({ target: { name: 'selCode', value: smst.selCode } }, () => updateState())
    }
  }

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } }

  const fetchDelBings = async() => {
    if(Object.keys(errors).length > 0) {
      alert('데이터에 에러가 있습니다. 화면의 에러를 확인해 주세요.')
      return false
    }
    const formData = new FormData()
    const lecture = generateData('lectures')
    const lschList = generateData('lschList')
    const data = {
      lecture: JSON.stringify(lecture),
      lschList: JSON.stringify(lschList),
    }
    const jsonData = JSON.stringify(data)
    formData.append('body', new Blob([jsonData], { type: 'application/json' }))

    const url = `/lecture/del/bings`
    openIndicator()
    const resp = await WebService.post(url, formData)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const delBings = JSON.parse(repMessage.delBings)
    return delBings
  }

  const handleFinalSave = async (area) => {
    const ret = await onSaveArea(area)
    if (ret) {
      set_editArea({ ...editArea, [area]: false })
      set_counter(counter + 1)
    }
  }

  const onClickSave = async (area) => {
    if (area === 'lsch') {
      const delBings = await fetchDelBings()
      if(delBings) {
        console.log('delBings',delBings )
        if (delBings.length > 0) {
          // 삭제 대상 있으면 팝업만 띄움 (저장은 perform에서)
          btnRef1.current.click()
          return
        }
      }
    }

    await handleFinalSave(area)
  }

  const onSaveArea = async (area) => {
    if(Object.keys(errors).length > 0) {
      alert('데이터에 에러가 있습니다. 화면의 에러를 확인해 주세요.')
      return false
    }

    const url = `/lecture/update/area/${area}`
    const formData = new FormData()
    const lecture = generateData('lectures')
    if(area === 'base') {

      const lectureTeachers = generateData('lectureTeachers')
      const interLectures = generateData('interLectures')
      const data = {
        lecture: JSON.stringify(lecture),
        lectureTeachers: JSON.stringify(lectureTeachers),
        interLectures: JSON.stringify(interLectures),
      }
      const jsonData = JSON.stringify(data)
      formData.append('body', new Blob([jsonData], { type: 'application/json' }))

    }
    else if(area === 'lsch') {
      const lschList = generateData('lschList')
      const data = {
        lecture: JSON.stringify(lecture),
        lschList: JSON.stringify(lschList),
      }
      const jsonData = JSON.stringify(data)
      formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    }
    else if(area === 'grade') {
      const ltgList = generateData('ltgList')
      const data = {
        lecture: JSON.stringify(lecture),
        ltgList: JSON.stringify(ltgList),
      }
      const jsonData = JSON.stringify(data)
      formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    }
    else if(area === 'fee') {
      const feeList = generateData('feeList')
      const data = {
        lecture: JSON.stringify(lecture),
        feeList: JSON.stringify(feeList),
      }
      const jsonData = JSON.stringify(data)
      formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    }
    else if(area === 'content') {
      const data = {
        lecture: JSON.stringify(lecture),
        oldAttchIdList: attchList.map((a) => a.id),
      }
      const jsonData = JSON.stringify(data)
      formData.append('body', new Blob([jsonData], { type: 'application/json' }))
      if(files.length > 1) {
        alert('강좌 소개 파일은 한 개만 가능합니다.')
        return
      }
      files.forEach((file, index) => {
        if (file instanceof File) {
          const f = new File([file], file.name, { type: file.type })
          formData.append('files', f)
        }
      })
    }
    else {
      alert('알 수 없는 편집 영역입니다.')
      return false
    }



    openIndicator()
    const resp = await WebService.post(url, formData)
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return false
    }

    openSnackbar('저장되었습니다.')

    const repMessage = JSON.parse(resp.repMessage)
    const newRecord = JSON.parse(repMessage.record)


    originRef.current = JSON.parse(JSON.stringify(factor))
    originRef.current.lectureTeachers = [...lectureTeachers]
    originRef.current.interLectures = [...interLectures]
    originRef.current.files = []
    originRef.current.lecCount = newRecord.lecCount
    originRef.current.autoLeccntYn = newRecord.autoLeccntYn

    const filename = newRecord.filename ?? ''
    const uname = newRecord.imgUrl ? newRecord.imgUrl.split('/').pop() : ''
    const path = uname ? newRecord.imgUrl.substring(0, newRecord.imgUrl.lastIndexOf('/')) : ''
    originRef.current.imgUrl = newRecord.imgUrl ? `/scm/repo/${path}/${encodeURIComponent(uname)}` : no_image
    originRef.current.attchList = [{ id: newRecord.attchId, name: filename }]


    set_attchList(originRef.current.attchList)
    set_imgUrl(originRef.current.imgUrl)
    set_files(originRef.current.files)
    updateState(originRef.current)

    updateRef.current = true

    return true
  }

  const EditButtons = ({area}) => {
    if (record.id === -1) {
      return null
    }

    return(
      <Grid item xs={12}>
        <Stack sx={{mt:2 }} direction="row" spacing={2}>
          <Button disabled={editArea[area]} variant="outlined" onClick={() =>{
            set_editArea({...editArea, [area]: true})

          }} >
                  편집
          </Button>
          <Button disabled={!editArea[area]} variant="outlined"  sx={{ml:2}} onClick={ async() => {
            set_lectureTeachers([...originRef.current.lectureTeachers])
            set_interLectures([...originRef.current.interLectures])
            set_attchList([...originRef.current.attchList])
            set_imgUrl(originRef.current.imgUrl)

            updateState(originRef.current)
            const err = await handleChange()

            set_editArea({...editArea, [area]: false})
            set_counter(counter + 1)
          }}>
                  취소
          </Button>
          <Button disabled={!editArea[area]} variant="contained" sx={{ml:2}}
            onClick={() => {
              onClickSave(area)
            }}
          >
            저장
          </Button>
          <ConfirmDialog
            btn={
              <FlatButton ref={btnRef1} style={{display:'none'}} />
            }
            title={'주의'}
            content={'요일이 변경 되어 기존 요일의 출석부가 삭제됩니다. 그래도 변경하시겠습니까?'}
            bc={'error'}
            preHandle={ async () => {
              return true
            }}
            perform={async () => {
              await handleFinalSave('lsch')
            }}
          />
        </Stack>

        <Divider sx={{mt:5}}/>
      </Grid>
    )
  }

  return (
    <ThemeProvider theme={customTheme}>
    <Container component="main" maxWidth="lg" style={{ fontSize: 10 }} >
      <>
        {renderAlert()}
      </>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        key={counter}
      >
        <Box component="form" noValidate sx={{ mt: 3 }}>
          <FormControl component="fieldset" variant="standard" fullWidth>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">기본정보</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    {record.id === -1 ? (
                      <>
                        <FormControl fullWidth>
                          <InputLabel id="gisu" size="small">
                            년도/기수
                          </InputLabel>
                          <Select
                            labelId="gisu"
                            required
                            label="년도/기수"
                            name={'smstId'}
                            defaultValue={activeRow['smstId']}
                            size="small"
                            onChange={async (e) => {
                              onChangeSmstId(e)
                            }}
                          >
                            {record.smstList.map((s, index) => {
                              return (
                                <MenuItem  value={s.id}>
                                  {s.year}/{s.gisu}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                      </>
                    ) : (
                      <TextField
                        size="small"
                        disabled={true}
                        required
                        fullWidth
                        label={'년도/기수'}
                        name={'groupId'}
                        defaultValue={activeRow.groupId}
                        onChange={handleChange}
                        InputProps={{
                          readOnly: true,
                        }}
                        style={{ backgroundColor: '#fafafa' }}
                      />
                    )}
                    <FormHelperTexts>{errors['smstId']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth>
                      <InputLabel id="teacher" size="small">
                        강사명
                      </InputLabel>
                      <Select
                        disabled={!canEdit('base')}
                        labelId="teacher"
                        required
                        label="강사명"
                        name={'userId'}
                        defaultValue={activeRow['userId']}
                        size="small"
                        onChange={async (e) => {
                          handleChange(e)
                        }}
                      >
                        {teacherList.map((l, index) => {
                          return (
                            <MenuItem value={l.id}>
                              {l.name}/{l.phone}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperTexts>{errors['userId']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      disabled={!canEdit('base')}
                      size="small"
                      required
                      fullWidth
                      label={'강좌제목'}
                      name={'title'}
                      defaultValue={activeRow['title']}
                      onChange={async (e) => {
                        await handleChange(e)
                      }}
                    />
                    <FormHelperTexts>{errors['title']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      disabled={!canEdit('base')}
                      size="small" required fullWidth label={'모집인원'} name={'rcrNum'}
                      defaultValue={activeRow['rcrNum']} onChange={handleChange}
                    />
                    <FormHelperTexts>{errors['rcrNum']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth>
                      <InputLabel id="sel-code" size="small">
                        선발방식
                      </InputLabel>
                      <Select
                        labelId="sel-code"
                        disabled={!canEdit('base')}
                        required
                        label="선발방식"
                        name={'selCode'}
                        defaultValue={activeRow['selCode']}
                        value={activeRow['selCode']}
                        size="small"
                        onChange={async (e) => {
                          await handleChange(e)
                          await handleChange({ target: { name: 'prevId', value: -1 } })
                          if (e.target.value !== 'S001') {
                            set_interLectures([])
                          }
                          updateState()
                        }}
                      >
                        {selCodeList.map((l, index) => {
                          return (
                            <MenuItem value={l.code}>
                              {l.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperTexts>{errors['selCode']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth>
                      <InputLabel id="prev-id" size="small">
                        선행강좌
                      </InputLabel>
                      <Select
                        disabled={!canEdit('base') || activeRow.selCode != 'S001'}
                        labelId="prev-id"
                        required
                        label="선행강좌"
                        name={'prevId'}
                        value={activeRow['prevId']}
                        size="small"
                        onChange={async (e) => {
                          handleChange(e)
                          updateState()
                        }}
                      >
                        {prevLectures.map((l, index) => {
                          return (
                            <MenuItem value={l.id}>
                              {l.title}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperTexts>{errors['prevId']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      disabled={!canEdit('base')}
                      size="small"
                      required fullWidth label={'장소'} name={'loc'} defaultValue={activeRow['loc']} onChange={handleChange}
                    />
                    <FormHelperTexts>{errors['loc']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      size="small"
                      required
                      disabled={true}
                      fullWidth
                      label={'신청인원'}
                      name={'reqNum'}
                      defaultValue={activeRow['reqNum']}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      size="small"
                      required
                      disabled={true}
                      fullWidth
                      label={'수강인원'}
                      name={'sttNum'}
                      defaultValue={activeRow['sttNum']}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth>
                      <InputLabel id="statCode" size="small">
                        상태
                      </InputLabel>
                      <Select
                        disabled={true}
                        labelId="statCode"
                        required
                        label="선발방식"
                        name={'statCode'}
                        defaultValue={activeRow['statCode']}
                        size="small"
                        onChange={async (e) => {
                          handleChange(e)
                        }}
                      >
                        {
                          statCodeList.map((l, index) => {
                            return (
                              <MenuItem  value={l.code}>
                                {l.name}
                              </MenuItem>
                            )
                          })
                        }∏
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={!canEdit('base')}
                        checked={activeRow.autoLeccntYn !== 'N'}
                        onChange={async (e) => {
                          await handleChange({ target: { name: 'autoLeccntYn', value: e.target.checked ? 'Y' : 'N' } })
                          await handleChange({ target: { name: 'lecCount', value: factor.lecCount } })
                          updateState()
                        }}
                      />
                    }
                    label="강좌횟수 자동계산"
                  />
                  <NumericTextField
                    disabled={!canEdit('base') || activeRow.autoLeccntYn !== 'N'}
                    size="small"
                    label="강좌 횟수"
                    name="lecCount"
                    maxLength={3}
                    value={activeRow.lecCount ?? ''}
                    onChange={async (v) => {
                      await handleChange({ target: { name: 'lecCount', value: v } })
                      updateState()
                    }}
                  />
                </Stack>
                <FormHelperTexts>{errors['lecCount']}</FormHelperTexts>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      (옵션) 추가 강사
                    </Typography>
                    <Typography sx={{ mt: 1 }} color={theme.palette.secondary.main}>
                      ※ 한 강좌에 2인 이상의 강사가 필요한 경우에만 추가하세요.
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <InputLabel id="teacher" size="small">
                        선택
                      </InputLabel>
                      <Select
                        disabled={!canEdit('base')}
                        labelId="teacher"
                        size="small"
                        value={null}
                        onChange={async (e) => {
                          // const x = [...lectureTeachers]
                          // x.push(e.target.value)
                          if (e.target.value.id == -1) {
                            set_lectureTeachers([])
                          }
                          else {
                            if (activeRow.userId == -1) {
                              alert('기본정보의 강사명을 먼저 선택해 주세요')
                            }
                            else {
                              if (activeRow.userId === e.target.value.id) {
                                // do nothing
                              }
                              else {
                                const found = lectureTeachers.find((r) => r.id === e.target.value.id)
                                if (!found) {
                                  set_lectureTeachers([...lectureTeachers, e.target.value])
                                }
                              }
                            }
                          }
                        }}
                      >
                        {teacherList.map((l, index) => {
                          return (
                            <MenuItem value={l}>
                              {l.name}/{l.phone}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {lectureTeachers.map((t, index) => (
                      <div  style={{ display: 'flex', flexDirection: 'row', alignItems:'center' }}>
                        <Typography>
                          {t.name}/{t.phone}
                        </Typography>
                        <IconButton
                          disabled={!canEdit('base')}
                          onClick={() => {
                            const idx = lectureTeachers.indexOf(t)
                            const data = lectureTeachers.filter((_, index) => index != idx)
                            set_lectureTeachers(data)
                          }}
                        >
                          <CloseIcon />

                        </IconButton>
                      </div>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      (옵션) 추가 선행 강좌
                    </Typography>
                    <Typography sx={{ mt: 1 }} color={theme.palette.secondary.main}>
                      ※ 선발방식이 기수강자 우선일 경우 강좌명이 다를 때(예 A반/B반 나뉘어져 있는 경우) 기수강자 요건이 필요한 경우 선택해 주세요.
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <InputLabel id="preLecture" size="small">
                        선택
                      </InputLabel>
                      <Select
                        disabled={!canEdit('base')}
                        labelId="preLecture"
                        size="small"
                        value={null}
                        onChange={async (e) => {
                          // const x = [...lectureTeachers]
                          // x.push(e.target.value)
                          if (e.target.value.id == -1) {
                            set_interLectures([])
                          }
                          else {
                            if (activeRow.prevId == -1) {
                              alert('기본정보의 선행강좌를 먼저 선택해 주세요')
                            }
                            else {
                              if (activeRow.prevId === e.target.value.id) {
                                // do nothing
                              }
                              else {
                                const found = interLectures.find((r) => r.id === e.target.value.id)
                                if (!found) {
                                  set_interLectures([...interLectures, e.target.value])
                                }
                              }
                            }
                          }
                        }}
                      >
                        {
                          prevLectures.map((l, index) => {
                            return (
                              <MenuItem  value={l}>
                                {l.title}
                              </MenuItem>
                            )
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {interLectures.map((t, index) => (
                      <div  style={{ display: 'flex', flexDirection: 'row', alignItems:'center' }}>
                        <Typography>{t.title}</Typography>
                        <IconButton
                          disabled={!canEdit('base')}
                          onClick={() => {
                            const idx = interLectures.indexOf(t)
                            const data = interLectures.filter((_, index) => index != idx)
                            set_interLectures(data)
                          }}
                        >
                          <CloseIcon />
                        </IconButton>

                      </div>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              <EditButtons area='base'/>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      요일 선택
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      {weekCodeList.map((s, index) => {
                        return (
                          <Fragment >
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={!canEdit('lsch')}
                                    color="primary"
                                    onChange={async (e) => {

                                      onChangeWeek(s.id, e)

                                      updateState()

                                    }}
                                    checked={activeRow.weekCodeList.find((s2) => s2.id === s.id) ? true : false}
                                  />
                                }
                                label={s.name}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                                <TimePicker
                                  disabled={!canEdit('lsch')}
                                  label={'시작시간'}
                                  ampm={false}
                                  minutesStep={5}
                                  inputFormat={'HH:mm'}
                                  value={activeRow.lschList.find((d) => d.weekCode === s.code)['startTime']}
                                  onChange={(newValue) => {
                                    const d = moment(new Date(newValue)).format(dateFormat)
                                    factor.lschList.find((d) => d.weekCode === s.code)['startTime'] = d
                                    if (factor.weekCodeList.findIndex((c) => c.code === s.code) < 0) {
                                      factor.weekCodeList.push(s)
                                    }
                                    handleChange({ target: { name: 'weekTime', value: activeRow.weekCodeList } })
                                    updateState()
                                  }}
                                  renderInput={(params) => <TextField size="small" {...params} />}
                                />
                              </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                                <TimePicker
                                  label={'종료시간'}
                                  disabled={!canEdit('lsch')}
                                  ampm={false}
                                  minutesStep={5}
                                  inputFormat={'HH:mm'}
                                  value={activeRow.lschList.find((d) => d.weekCode === s.code)['endTime']}
                                  onChange={(newValue) => {
                                    const d = moment(new Date(newValue)).format(dateFormat)
                                    factor.lschList.find((d) => d.weekCode === s.code)['endTime'] = d
                                    if (factor.weekCodeList.findIndex((c) => c.code === s.code) < 0) {
                                      factor.weekCodeList.push(s)
                                    }
                                    handleChange({ target: { name: 'weekTime', value: activeRow.weekCodeList } })
                                    updateState()
                                  }}
                                  renderInput={(params) => <TextField size="small" {...params} />}
                                />
                              </LocalizationProvider>
                            </Grid>
                            <Grid xs={12} sm={3}></Grid>
                          </Fragment>
                        )
                      })}
                    </Grid>
                    <FormHelperTexts>{errors['weekCodeList']}</FormHelperTexts>
                    <FormHelperTexts>{errors['weekTime']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <EditButtons area='lsch'/>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                      대상 학년
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {ltgList.map((l, index) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={!canEdit('grade')}
                              color="primary"
                              onChange={(e) => {
                                onChangeGrade(l.grade, e)
                                updateState()
                              }}
                              checked={activeRow.ltgList.find((l2) => l2.grade === l.grade) ? true : false}
                            />
                          }
                          label={l.grade}
                        />
                      )
                    })}
                  </Grid>
                </Grid>
                <FormHelperTexts>{errors['ltgList']}</FormHelperTexts>
              </Grid>
              <EditButtons area='grade'/>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ mt: 2 }}>
                  강좌 내용
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  disabled={!canEdit('content')}
                  rows={5} fullWidth label={'내용'} name={'content'} defaultValue={activeRow['content']}
                  onChange={handleChange}
                  multiline
                />
                <FormHelperTexts>{errors['content']}</FormHelperTexts>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={imgUrl} width="100" />
                    {files.filter((r) => r.name?.length > 0).length > 0 || attchList.filter((r) => r.name?.length > 0).length > 0 ? (
                      <IconButton disabled={!canEdit('content')}
                        style={{ fontSize: '2em', cursor: 'pointer', borderRadius: '50%' }}
                        onClick={() => {
                          set_files([])
                          set_attchList([])
                          set_imgUrl(no_image)
                        }}
                      >
                        <CloseIcon />
                      </IconButton>

                    ) : null}
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      variant="standard"
                      type="text"
                      value={files.length > 0 ? files[0].name : attchList.length > 0 ? attchList[0].name : ''}
                      fullWidth
                      label="강좌 소개 파일"
                      InputLabelProps={{ shrink: files.length > 0 || attchList.length > 0 }}
                      InputProps={{
                        endAdornment: (
                          <IconButton component="label" disabled={!canEdit('content')}>
                            <AttachFileOutlinedIcon />
                            <input
                              styles={{ display: 'none' }}
                              type="file"
                              accept=".jpg, .png"
                              hidden
                              onChange={(e) => {
                                onChangeFile(e)
                              }}
                            />
                          </IconButton>
                        ),
                      }}
                    />
                    <FormHelperTexts>{errors['files']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <EditButtons area='content'/>
              {/* 요금, fees */}
              <Grid item xs={12}>
                <Typography variant="h6">강좌요금 정보</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs>
                    <FormControl fullWidth>
                      <InputLabel id="feeCode" size="small">
                        요금 선택
                      </InputLabel>
                      <Select
                        labelId="feeCode"
                        disabled={!canEdit('fee')}
                        required
                        label="feeCode"
                        size="small"
                        onChange={async (e) => {
                          const newRecord = { ...activeRow }
                          const idx = newRecord.feeList.findIndex((r) => r.feeCode === e.target.value)
                          if (idx < 0) {
                            const now = moment().format(dateFormat)
                            newRecord.feeList.push({
                              id: -1,
                              lectureId: activeRow.id,
                              feeCode: e.target.value,
                              name: '',
                              statCode: 'S001',
                              price: 0,
                              uptTime: now,
                              regTime: now,
                            })
                            await handleChange({ target: { name: 'feeList', value: newRecord.feeList } }, () => updateState())
                          }
                        }}
                      >
                        {feeCodeList.map((l, index) => {
                          return (
                            <MenuItem  value={l.code}>
                              {l.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Divider orientation="vertical" flexItem sx={{ ml: 5 }} />
                  <Grid item xs={9}>
                    <Grid container spacing={1}>
                      {activeRow.feeList.map((fee, index) => {
                        return (
                          <Fragment >
                            <Grid item xs={3}></Grid>
                            <Grid item xs={3}>
                              <IconButton
                                disabled={!canEdit('fee')}
                                onClick={async () => {
                                  const list = activeRow.feeList.filter((r) => r.feeCode !== fee.feeCode)
                                  await handleChange({ target: { name: 'feeList', value: list } })
                                  updateState()
                                }}
                              >
                                <RemoveCircleOutlineIcon />
                              </IconButton>
                            </Grid>
                            <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center' }}>
                              <Typography variant="body2">{feeCodeList.find((r) => r.code === fee.feeCode)?.name ?? null}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <TextField
                                disabled={!canEdit('fee')}
                                size="small"
                                label="가격"
                                defaultValue={fee.price}
                                onChange={(e) => {
                                  const found = factor.feeList.find((r) => r.feeCode === fee.feeCode)
                                  if (found) {
                                    found.price = e.target.value
                                    handleChange({ target: { name: 'feePrice', value: found.price } })
                                    updateState()
                                  }
                                }}
                              />
                            </Grid>
                          </Fragment>
                        )
                      })}
                    </Grid>
                  </Grid>
                </Grid>
                <FormHelperTexts>{errors['feeList']}</FormHelperTexts>
                <FormHelperTexts>{errors['feePrice']}</FormHelperTexts>
              </Grid>
              <EditButtons area='fee'/>
              <Grid item xs={12}>
                <FormHelperTexts>
                  {errors['error']
                    ? errors['error'].split('\n').map((err, index) => {
                      return (
                        <Typography component="div">
                          {err}
                        </Typography>
                      )
                    })
                    : null}
                </FormHelperTexts>
              </Grid>
            </Grid>
          </FormControl>
          <FormHelperTexts>{registerError}</FormHelperTexts>
        </Box>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button disabled={false} variant="outlined" sx={{ mt: 1, mr: 1, width: 100, mb: 10 }}
            onClick={() => {
              // if(record.id >= 0) {
              //   for(const [name, value] of Object.entries(editArea)) {
              //     if(value) {
              //       alert('현재 편집 중인 데이터가 있습니다. 취소 또는 저장을 선택 후 창을 닫아 주세요.')
              //       return
              //     }
              //   }
              //   handleClose()
              // }
              // else {
              //   handleClose()
              // }
              handleClose()
            }}
          >
            닫기
          </Button>
          {
            record.id == -1 ? (
              <Button disabled={false} variant="contained" sx={{ mt: 1, width: 100, mb: 10 }}
                onClick={async () => {
                  // handleChange(null, () => {
                  //   onSubmit()
                  // })
                  const errs = await handleChange()
                  console.log('errs=>', errs)
                  if(Object.keys(errs).length > 0) {
                    alert('데이터에 에러가 있습니다. 화면의 에러를 확인해 주세요.')
                    return false
                  }
                  else {
                    await onSubmit()
                  }

                  // handleChange(null, () => {
                  //   onSubmit()
                  // })
                }}
              >
                저장
              </Button>
            ): null
          }

        </div>
      </Box>

    </Container>
    </ThemeProvider>
  )
}
export default ManagerLecturePartDetail
